import React from 'react';
import { useIntl } from 'react-intl';
import Html from 'components/html';
import Button from 'components/button/button';
import { link } from 'services/navigation';
import Link from 'components/link';

import ModelsGallery from './models-gallery';
import { testId } from './success-stories-banner.settings';
import messages from './success-stories-banner.i18n';
import styles from './success-stories-banner.module.scss';

const SuccessStoriesBanner: React.FunctionComponent<unknown> = () => {
  const { formatMessage } = useIntl();
  const translation = messages.pages.landing.successStoriesBanner.livejasmin;

  return (
    <Html.div className={[styles.successStoriesBanner, 'py-12 py-md-20 w-100']} testId={testId.component}>
      <Html.div className={[styles.successStories, 'mb-4 px-6']}>
        {formatMessage(translation.successStories, {
          b: (contents: React.ReactNode) => <Html.b className={styles.highlight}>{contents}</Html.b>,
        })}
      </Html.div>
      <Html.header className={[styles.fromHuge, 'mb-8 px-6']}>{formatMessage(translation.fromHuge)}</Html.header>
      <ModelsGallery />
      <Html.div className="text-center mt-10">
        <Link href={link.signup()}>
          <Button testId={testId.joinNowButton} className="w-100 w-md-auto mb-0 text-center" size="xl">
            {formatMessage(translation.joinNow)}
          </Button>
        </Link>
      </Html.div>
    </Html.div>
  );
};

export default SuccessStoriesBanner;
